/**
 * Helpers puros del flujo post-emisión de factura por mail (testeables sin React).
 */

export interface PostEmisionEmailOffer {
  ofrecerEnvio: boolean;
  smtpConfigurado: boolean;
  clienteTieneEmail: boolean;
  emailsSugeridos: string[];
  nombreCliente?: string | null;
  comprobanteLabel?: string | null;
}

export interface PostEmisionEmailPreviewLike {
  emailsSugeridos?: string[] | null;
  smtpConfigurado?: boolean;
  nombreCliente?: string | null;
  comprobanteLabel?: string | null;
}

export function normalizePostEmisionOffer(raw: Record<string, unknown>): PostEmisionEmailOffer {
  const emailsRaw = raw.emailsSugeridos ?? raw.EmailsSugeridos;
  const emails = Array.isArray(emailsRaw)
    ? emailsRaw.map((e) => String(e ?? '').trim()).filter(Boolean)
    : [];
  const smtp = Boolean(raw.smtpConfigurado ?? raw.SmtpConfigurado);
  const ofrecer = Boolean(raw.ofrecerEnvio ?? raw.OfrecerEnvio ?? smtp);
  const clienteTiene = Boolean(
    raw.clienteTieneEmail ?? raw.ClienteTieneEmail ?? emails.length > 0,
  );
  return {
    ofrecerEnvio: ofrecer,
    smtpConfigurado: smtp,
    clienteTieneEmail: clienteTiene,
    emailsSugeridos: emails,
    nombreCliente: (raw.nombreCliente ?? raw.NombreCliente ?? null) as string | null,
    comprobanteLabel: (raw.comprobanteLabel ?? raw.ComprobanteLabel ?? null) as string | null,
  };
}

export function offerFromEnvioPreview(preview: PostEmisionEmailPreviewLike): PostEmisionEmailOffer {
  const emails = preview.emailsSugeridos ?? [];
  return {
    ofrecerEnvio: Boolean(preview.smtpConfigurado),
    smtpConfigurado: Boolean(preview.smtpConfigurado),
    clienteTieneEmail: emails.length > 0,
    emailsSugeridos: emails,
    nombreCliente: preview.nombreCliente,
    comprobanteLabel: preview.comprobanteLabel,
  };
}

/** Decisión UI: ¿mostrar pregunta post-emisión? */
export function debePreguntarEnvioPostEmision(offer: Pick<PostEmisionEmailOffer, 'ofrecerEnvio' | 'smtpConfigurado'>): boolean {
  return Boolean(offer.ofrecerEnvio && offer.smtpConfigurado);
}

/** Decisión UI: ¿enviar directo sin diálogo? */
export function puedeEnviarDirectoAlCliente(
  offer: Pick<PostEmisionEmailOffer, 'smtpConfigurado' | 'clienteTieneEmail' | 'emailsSugeridos'>,
): boolean {
  return Boolean(
    offer.smtpConfigurado &&
      offer.clienteTieneEmail &&
      (offer.emailsSugeridos?.length ?? 0) > 0,
  );
}

export const POST_EMISION_EMAIL_ROUTES = {
  oferta: (nro: number) => `/api/FacturasVenta/${nro}/envio-email/oferta-post-emision`,
  preview: (nro: number) => `/api/FacturasVenta/${nro}/envio-email`,
  enviarCliente: (nro: number) => `/api/FacturasVenta/${nro}/enviar-email-cliente`,
  enviarManual: (nro: number) => `/api/FacturasVenta/${nro}/enviar-email`,
} as const;

export const CODIGO_SIN_EMAIL_CLIENTE = 'SIN_EMAIL_CLIENTE';
